import { createAction } from 'retreon';

export const leave = createAction<string>('call/leave');
